import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiTableCell from '@material-ui/core/TableCell';
// Core components
import Checkbox from '../Checkbox';

const TableCell = ({
  role,
  selected,
  expanded,
  align,
  className,
  noPadding,
  noBorder,
  colSpan,
  children,
}) => {
  // Checkbox cell
  if (role === 'checkbox') {
    return (
      <MuiTableCell padding="checkbox">
        <Checkbox checked={selected} />
      </MuiTableCell>
    );
  }

  // Style
  let style = {};

  if (expanded) {
    style = {
      ...style,
      borderBottom: 'none',
    };
  }

  if (noBorder) {
    style = {
      ...style,
      borderBottom: 'none',
    };
  }

  if (noPadding) {
    style = {
      ...style,
      paddingTop: 0,
      paddingBottom: 0,
    };
  }

  // Component props
  const tableCellProps = {
    align, className, style, colSpan,
  };

  return (
    <MuiTableCell {...tableCellProps}>
      { children }
    </MuiTableCell>
  );
};

TableCell.propTypes = {
  role: PropTypes.oneOf(['default', 'checkbox']),
  selected: PropTypes.bool,
  expanded: PropTypes.bool,
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  className: PropTypes.string,
  noPadding: PropTypes.bool,
  noBorder: PropTypes.bool,
  colSpan: PropTypes.number,
  children: PropTypes.node,
};

TableCell.defaultProps = {
  role: 'default',
  selected: false,
  expanded: false,
  align: 'inherit',
  className: null,
  noPadding: false,
  noBorder: false,
  colSpan: 1,
  children: null,
};

export default TableCell;



// WEBPACK FOOTER //
// ./components/core/table/TableCell.js